<template>
  <div>


    <b-modal
      id="simple-convert-modal"
      title="Simple Product Conversion"
      @show="loadProducts"
      @hidden="resetState"
      hide-footer
    >
      <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>

      <b-alert v-if="success" variant="success" show>
        Deducted 1 {{ result.from_product }} → Added {{ result.added }} {{ result.to_product }}
      </b-alert>

      <b-form @submit.prevent="convert">
        <b-form-group label="From Product">
          <b-form-select
            v-model="form.from_product_id"
            :options="productOptions"
            required
          />
        </b-form-group>

        <b-form-group label="To Product">
          <b-form-select
            v-model="form.to_product_id"
            :options="productOptions"
            required
          />
        </b-form-group>

        <b-form-group label="Outcome Quantity (to add)">
          <b-form-input
            v-model.number="form.outcome_quantity"
            type="number"
            step="0.0001"
            min="0.0001"
            required
          />
        </b-form-group>

      <b-button
  type="submit"
  variant="primary"
  block
  :disabled="loading || success"
>
  <span v-if="loading">
    <b-spinner small></b-spinner> Processing...
  </span>
  <span v-else>Convert</span>
</b-button>

      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error: null,
      success: false,
      products: [],
      result: {},
      form: {
        from_product_id: null,
        to_product_id: null,
        outcome_quantity: null
      }
    }
  },

  computed: {
    productOptions() {
      return this.products.map(p => ({
        value: p.id,
        text: p.product
      }))
    }
  },

  methods: {
    async loadProducts() {
      this.resetState()
      const res = await axios.get('/api/only-products')
      this.products = res.data.data || res.data
    },

    async convert() {
      if (this.loading) return

      this.loading = true
      this.error = null
      this.success = false

      try {
        const res = await axios.post('/api/products/simple-convert', this.form)
        this.result = res.data.data
        this.success = true

        // auto close after success display
        setTimeout(() => {
          this.$bvModal.hide('simple-convert-modal')
        }, 1200)

      } catch (e) {
        this.error = e.response?.data?.message || 'Conversion failed'
      } finally {
        this.loading = false
      }
    },

    resetState() {
      this.loading = false
      this.error = null
      this.success = false
      this.result = {}
      this.form = {
        from_product_id: null,
        to_product_id: null,
        outcome_quantity: null
      }
    }
  }
}

</script>
